<div class="tags-dialog">
  <div class="tags-dialog-content">
    <div class="dialog-header">
      <span></span>

      <h1 class="tag-heading" transloco="tags.dialog.header"></h1>

      <button
        type="button"
        class="dialog-close"
        (click)="closeDialog()"
        aria-label="Close dialog">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <p class="info-label tag-info" transloco="tags.dialog.description">Add up to 3 tags.</p>
    <h3 class="tag-heading" transloco="tags.dialog.selectedTags">Selected Tags</h3>

    <p class="info-label tag-info" *ngIf="selectedTags.length === 0" transloco="tags.dialog.noSelectedTags">No tags have been added to this page yet.</p>

    <div class="selected-tags-row" *ngIf="selectedTags.length > 0">
      <span *ngFor="let tag of selectedTags">
        <aero-tags [name]="tag.name" [showCross]="true" (crossClicked)="removeSelectedTag(tag)"
                   [color]="tag.colorCode"></aero-tags>
      </span>
    </div>

    <p-tabView class="underline-tabs">
      <p-tabPanel header="{{ 'tags.dialog.recent' | transloco }}">
        <h3 *ngIf="recentTags.length === 0" transloco="tags.dialog.noRecentTags">No recently used tags yet.</h3>
        <div *ngIf="recentTags.length > 0" class="card">
          <p-table
            #recentTagsTable
            [value]="recentTags"
            [(selection)]="selectedTags"
            dataKey="id"
            [globalFilterFields]="['name', 'description']"
            class="tag-table"
            [scrollable]="true"
            scrollHeight="13rem"
            (onRowSelect)="onTagChecked($event)"
            (onRowUnselect)="onTagUnchecked($event)"
          >

            <!-- SEARCH BAR -->
            <ng-template pTemplate="caption">
              <div class="table-caption">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <aero-input placeholder="{{ 'tags.dialog.searchPlaceholder' | transloco }}"
                          (input)="recentTagsTable.filterGlobal($any($event.target).value, 'contains')">
              </aero-input>
            </span>
              </div>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">
                </th>
                <th transloco="tags.dialog.tagName">Name</th>
                <th transloco="tags.dialog.tagDescription">Description</th>
              </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-tag>
              <tr>
                <td>
                  <p-tableCheckbox [value]="tag" [disabled]="isCheckboxDisabled(tag)"></p-tableCheckbox>
                </td>
                <td>{{ tag.name }}</td>
                <td>{{ tag.description }}</td>
              </tr>
            </ng-template>

          </p-table>
        </div>

      </p-tabPanel>

      <p-tabPanel header="{{ 'group_type_ORGANIZATION' | translate }}">
        <h3 *ngIf="organizationTags.length === 0" transloco="tags.dialog.noOrgTags">No organization tags available.</h3>
        <div *ngIf="organizationTags.length > 0" class="card">
          <p-table
            #orgTagsTable
            [value]="organizationTags"
            [(selection)]="selectedTags"
            dataKey="id"
            [globalFilterFields]="['name', 'description']"
            class="tag-table"
            [scrollable]="true"
            scrollHeight="13rem"
            (onRowSelect)="onTagChecked($event)"
            (onRowUnselect)="onTagUnchecked($event)"
          >

            <!-- SEARCH BAR -->
            <ng-template pTemplate="caption">
              <div class="table-caption">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <aero-input placeholder="{{ 'tags.dialog.searchPlaceholder' | transloco }}"
                          (input)="orgTagsTable.filterGlobal($any($event.target).value, 'contains')">
              </aero-input>
            </span>
              </div>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">
                </th>
                <th transloco="tags.dialog.tagName">Name</th>
                <th transloco="tags.dialog.tagDescription">Description</th>
              </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-tag>
              <tr>
                <td>
                  <p-tableCheckbox [value]="tag" [disabled]="isCheckboxDisabled(tag)"></p-tableCheckbox>
                </td>
                <td>{{ tag.name }}</td>
                <td>{{ tag.description }}</td>
              </tr>
            </ng-template>

          </p-table>

        </div>
      </p-tabPanel>

      <p-tabPanel header="{{ 'tags.dialog.personal' | transloco }}">
        <div class="create-btn-right" *ngIf="myTags.length === 0">
          <aero-button
            labelCode="create_collection_submit_label"
            (onClick)="createTag()"
            [size]="smallButton">
          </aero-button>
        </div>
        <h3 *ngIf="myTags.length === 0" transloco="tags.dialog.noTagsCreated">No tags created by you yet. Click Create to add one.</h3>
        <div *ngIf="myTags.length > 0" class="card">
          <p-table
            #myTagsTable
            [value]="myTags"
            [(selection)]="selectedTags"
            dataKey="id"
            [globalFilterFields]="['name', 'description']"
            class="tag-table"
            [scrollable]="true"
            scrollHeight="13rem"
            (onRowSelect)="onTagChecked($event)"
            (onRowUnselect)="onTagUnchecked($event)"
          >

            <!-- SEARCH BAR -->
            <ng-template pTemplate="caption">
              <div class="table-caption">
                <div class="caption-content">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <aero-input placeholder="{{ 'tags.dialog.searchPlaceholder' | transloco }}"
                            (input)="myTagsTable.filterGlobal($any($event.target).value, 'contains')">
                </aero-input>
              </span>
                  <aero-button  [aeroTooltip]="myTags.length >= 20 ? ('tags.dialog.maxTagsLimit' | transloco) : null"
                                [disabled]="myTags.length >= 20" labelCode="create_collection_submit_label"
                                (onClick)="createTag()" [size]="smallButton"></aero-button>
                </div>
              </div>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">
                </th>
                <th transloco="tags.dialog.tagName">Name</th>
                <th transloco="tags.dialog.tagDescription">Description</th>
                <th></th>
              </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-tag>
              <tr>
                <td>
                  <p-tableCheckbox [value]="tag" [disabled]="isCheckboxDisabled(tag)"></p-tableCheckbox>
                </td>
                <td>{{ tag.name }}</td>
                <td>{{ tag.description }}</td>
                <!-- Actions -->
                <td class="actions">
                  <span class="icon icon-edit" aeroTooltip="{{ 'button_edit' | translate }}" (click)="editTag(tag)">
                    <i class="fas fa-edit"></i>
                  </span>
                  <span class="icon icon-delete" aeroTooltip="{{ 'delete' | translate | titlecase }}" (click)="showConfirmDialog(tag)">
                    <i class="fa fa-trash-alt"></i>
                  </span>
                </td>
              </tr>
            </ng-template>

          </p-table>

        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
  <aero-button class="save-btn-right" labelCode="button_save"
               (onClick)="closeDialog()" [size]="smallButton"></aero-button>
  <div class="tags-dialog-note">
    <p class="tags-note tag-info" transloco="tags.dialog.note">Note: Click on checkbox to add tags to page</p>
  </div>
</div>
